import { useState, useEffect } from "react";
import { Alert, Button, Slide, Snackbar, Typography } from "@mui/material";

const SnackBarMessage = ({ severity, message, open, onClose, undo, hideDuration = 3000 }) => {
	const [snackOpen, setSnackOpen] = useState(false);

	const handleSnackClose = (event, reason) => {
		if (reason === "clickaway") {
			return;
		}

		setSnackOpen(false);
		onClose();
	};

	function TransitionLeft(props) {
		return <Slide {...props} direction="left" />;
	}

	useEffect(() => {
		setSnackOpen(open);
	}, [open]);

	return (
		<Snackbar open={snackOpen} autoHideDuration={hideDuration} onClose={handleSnackClose} anchorOrigin={{ vertical: "top", horizontal: "center" }} TransitionComponent={TransitionLeft}>
			<Alert onClose={handleSnackClose} severity={severity} id="alert-style-1">
				{message}
				{undo && (
					<Button>
						<Typography>DESHACER</Typography>
					</Button>
				)}
			</Alert>
		</Snackbar>
	);
};

export default SnackBarMessage;
